import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles.css';

const Home = () => {
    return (
        <div className="center-container">
            <div className="content-section">
                <h1>Hello!</h1>
                <p>
                    I’m <strong>Mark Veerasingam</strong>, an AI Compiler Engineer at <strong>IBM</strong> in Waterford, Ireland.
                    My work sits between research and systems engineering, specializing in <strong>high-performance computing and
                        hardware acceleration for artificial intelligence.</strong>
                </p>
            </div>

            <div className="content-section">
                <h1>Bio</h1>
                <p>
                    Currently, I work on the open-source compiler and runtime infrastructure for <strong>IBM’s Spyre AI Accelerator</strong>.
                    My focus is on enabling the PyTorch ecosystem for IBM's PCIe hardware Accelerators.
                </p>
                <p>
                    Prior to IBM, I was an Embedded Software Engineer at <strong>Analog Devices</strong>, where I developed
                    digital twins for automotive <strong>Battery Management Systems (BMS)</strong>. I hold a
                    Bachelor’s in Computer Engineering from Atlantic Technological University, where I was a recipient of the
                    <strong> Scholarship of Academic Excellence</strong> from Analog Devices.
                </p>
            </div>

            <div className="content-section">
                <h2>What I'm Learning</h2>
                <p>
                    Lately I've been learning <strong>machine learning compilers</strong> with LLVM and
                    MLIR. As hardware approaches it's physical limits and to quote internet comedian Programmers Are Also Human, <em>"For every doubling in network and hardware speed, inefficiency in software quadruples."</em>. <br />
                    The next breakthroughs in hardware performance will come from smarter compilers, not just faster chips.
                </p>
                <p>
                    You can also learn more about my work at
                    <strong> IBM</strong> and <strong>Analog Devices</strong>{' '}
                    <NavLink to="/experience">
                        here.
                    </NavLink>
                </p>
            </div>
        </div>
    );
};

export default Home;
